import { defineComponent as _defineComponent } from 'vue'
import CareerconnectionMediaLogo from '@/components/realtime-transfer/CareerconnectionMediaLogo.vue'
import { reportImageCacheStat } from '@/utils/image-cache-stats'


export default /*#__PURE__*/_defineComponent({
  __name: 'CompletedAutoRtConsent',
  props: {
    info: null,
    hasPartnerTerms: { type: Boolean },
    partnerTermsHtml: null,
    agreed: { type: Boolean }
  },
  emits: ["update:agreed"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:agreed', value: boolean): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  /** autoRtState.info（クライアント名・規約 URL など） */
  info: Record<string, any>
  hasPartnerTerms: boolean
  partnerTermsHtml: string
  agreed: boolean
};

/**
 * auto_rt（完了画面の自動送客）の同意ブロック。DownloadItem.vue から文言ごと移設した。
 * 表示条件・同意状態の正本は useCompletedOutput 側（このコンポーネントは presentational）。
 */




/** ロゴがキャッシュ/SW/ネットワークのどこから来たかを Whatap へ送る（DownloadItem から移設） */
function onLogoLoad(event: Event) {
  reportImageCacheStat(event.target as HTMLImageElement, {
    dialogName: 'auto_rt',
    clientId: props.info.clientId,
    permissionType: props.info.permissionType
  })
}

return { __sfc: true,props, emit, onLogoLoad, CareerconnectionMediaLogo }
}

})